export { default as LandingPagesContentMapper } from './lib/landing-pages-content-mapper';
